import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchOnlineReviewByPropertiesData } from "../actions/fetchOnlineReviewData"
import { parseFilters } from "../../Filters/utils/fetchData"
import get from "lodash/get"

const useFetchOnlineReviewByPropertiesData = ({ campaign, customFilters, skip = false }) => {

    const [data, setData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const data_per_page = 10;
    const dispatch = useDispatch()
    const { applied_filter_values } = useSelector(e => e?.filterReducer);

    useEffect(() => {
        const filters = customFilters || parseFilters(applied_filter_values);
        if (!skip) {
            setIsLoading(true)
            dispatch(fetchOnlineReviewByPropertiesData({
                filters: { ...filters, filters: { ...filters.filters, limit: data_per_page, offset: (page - 1) * data_per_page } },
                campaign: campaign,
                onSuccess: (data) => {
                    setData(data)
                    const totalRecords = get(data, "contents.total_records", 0)
                    setTotalPages(totalRecords)
                    setIsLoading(false)
                },
                onError: (data) => {
                    setData(data)
                    setIsLoading(false)
                }
            }))
        }
    }, [page, customFilters, applied_filter_values, skip, dispatch, campaign])

    function onPageChange(pageNumber) {
        setPage(pageNumber)
    }


    return { data, onPageChange, data_per_page, isLoading, page, totalPages }


}

export default useFetchOnlineReviewByPropertiesData